export const translations = {
  en: {
    meta: {
      title: 'Zont - Premium Transportation & Airport Transfer Service',
      description: 'Book professional drivers and airport transfers in 16 cities worldwide. Real-time tracking, transparent pricing, and 24/7 customer support. Download the app now!',
      keywords: 'airport transfer, car service, private driver, taxi booking, ride sharing, transportation service',
    },
    nav: {
      becomeDriver: 'Become a Driver',
      becomeClient: 'Become a Client',
      countries: 'Countries',
      help: 'Help',
      signin: 'Sign in',
      signup: 'SIGN UP',
      signout: 'Sign out',
      hello: 'Hello',
      myBookings: 'My Bookings',
      myAccount: 'My Account',
    },
    hero: {
      title1: 'Press a Button,',
      title2: 'Get a Ride',
      subtitle: 'is the smartest way to move around your city.',
      getApp: 'Get the app for',
      iphone: 'iPhone',
      and: 'and',
      android: 'Android',
      downloadOn: 'Download on the',
      appStore: 'App Store',
      getItOn: 'GET IT ON',
      googlePlay: 'Google Play',
    },
    stats: {
      cities: 'Cities Worldwide',
      customers: 'Happy Customers',
      drivers: 'Professional Drivers',
      rating: 'Average Rating',
    },
    features: {
      title: 'Why Choose Zont?',
      subtitle: 'Professional transportation service with the best prices and highest quality standards',
      confirmedBooking: 'Confirmed Booking',
      confirmedDesc: 'Get instant confirmation and driver details 3 hours before pickup',
      realTimeTracking: 'Real-Time Tracking',
      realTimeDesc: 'Track your driver in real-time and know exactly when they will arrive',
      professionalDrivers: 'Professional Drivers',
      professionalDesc: 'All drivers are verified, licensed, and highly rated by our community',
      transparentPricing: 'Transparent Pricing',
      transparentDesc: 'No hidden fees. See the exact price before you book',
    },
    booking: {
      title: 'Book Your Airport Transfer & Private Driver Service',
      description: 'Choose from premium sedans, luxury vehicles, and business vans at competitive rates. Zont provides professional airport transfers and private driver services at the lowest rates across the globe. Book your airport taxi, city transfer, or hourly car rental in any city worldwide. Track your driver in real-time, ensuring quality, safety, and punctuality for every ride.',
      oneWay: 'One way',
      hourlyRental: 'Hourly Rental',
      pickup: 'Pick up',
      pickupPlaceholder: 'From:',
      dropoff: 'Drop off',
      dropoffPlaceholder: 'To:',
      hourlyNA: 'N/A for hourly rental',
      date: 'Date',
      time: 'Time',
      search: 'SEARCH',
      searching: 'Searching...',
    },
    testimonials: {
      title: 'What Our Customers Say',
      subtitle: 'Trusted by thousands of travelers worldwide',
      review1: 'Perfect service for airport transfers! The driver was waiting for me with a sign, very professional.',
      review2: 'I use Zont for all my business trips. Reliable, on-time, and the drivers know the best routes.',
      review3: 'Great prices and excellent service. I highly recommend Zont for anyone visiting Armenia!',
      name1: 'Marie Dubois',
      location1: 'Paris, France',
      name2: 'James Wilson',
      location2: 'London, UK',
      name3: 'Anna Petrosyan',
      location3: 'Yerevan, Armenia',
    },
    cta: {
      title: 'Ready to Experience Premium Transportation?',
      subtitle: 'Join thousands of satisfied customers. Book your first ride today!',
      bookNow: 'BOOK NOW',
    },
    worldwide: {
      title: 'Your Best Worldwide Option',
      description: 'With a global on-demand network already spanning across',
      cities: '16 cities',
      description2: ", we're taking transportation and instant ordering to the next level.",
    },
    footer: {
      description: 'The smartest way to move around your city.',
      quickLinks: 'Quick Links',
      aboutUs: 'About Us',
      terms: 'Terms of Use',
      privacy: 'Privacy Policy',
      followUs: 'Follow Us',
      copyright: '© 2025 Zont Technologies Inc. All rights reserved.',
    },
  },
  fr: {
    meta: {
      title: 'Zont - Service de Transport Premium & Transfert Aeroport',
      description: 'Reservez des chauffeurs professionnels et transferts aeroport dans plus de 16 villes. Suivi en temps reel, prix transparents et support 24/7.',
      keywords: 'transfert aeroport, service de voiture, chauffeur prive, reservation taxi, covoiturage, service de transport',
    },
    nav: {
      becomeDriver: 'Devenir Chauffeur',
      becomeClient: 'Devenir Client',
      countries: 'Pays',
      help: 'Aide',
      signin: 'Se connecter',
      signup: "S'INSCRIRE",
      signout: 'Se deconnecter',
      hello: 'Bonjour',
      myBookings: 'Mes Reservations',
      myAccount: 'Mon Compte',
    },
    hero: {
      title1: 'Appuyez sur un Bouton,',
      title2: 'Obtenez un Trajet',
      subtitle: 'est le moyen le plus intelligent de se deplacer en ville.',
      getApp: "Telechargez l'application pour",
      iphone: 'iPhone',
      and: 'et',
      android: 'Android',
      downloadOn: 'Telecharger sur',
      appStore: 'App Store',
      getItOn: 'DISPONIBLE SUR',
      googlePlay: 'Google Play',
    },
    stats: {
      cities: 'Villes dans le Monde',
      customers: 'Clients Satisfaits',
      drivers: 'Chauffeurs Professionnels',
      rating: 'Note Moyenne',
    },
    features: {
      title: 'Pourquoi Choisir Zont ?',
      subtitle: 'Service de transport professionnel avec les meilleurs prix et standards de qualite',
      confirmedBooking: 'Reservation Confirmee',
      confirmedDesc: 'Confirmation instantanee et details du chauffeur 3 heures avant le depart',
      realTimeTracking: 'Suivi en Temps Reel',
      realTimeDesc: 'Suivez votre chauffeur en temps reel et sachez exactement quand il arrivera',
      professionalDrivers: 'Chauffeurs Professionnels',
      professionalDesc: 'Tous les chauffeurs sont verifies, agrees et hautement notes par notre communaute',
      transparentPricing: 'Tarification Transparente',
      transparentDesc: 'Aucun frais cache. Voyez le prix exact avant de reserver',
    },
    booking: {
      title: 'Reservez Votre Transfert Aeroport & Chauffeur Prive',
      description: 'Choisissez parmi des berlines premium, vehicules de luxe et vans a tarifs competitifs. Zont fournit des transferts aeroport professionnels et services de chauffeur prive aux meilleurs tarifs mondiaux.',
      oneWay: 'Aller simple',
      hourlyRental: 'Location Horaire',
      pickup: 'Depart',
      pickupPlaceholder: 'De :',
      dropoff: 'Arrivee',
      dropoffPlaceholder: 'A :',
      hourlyNA: 'N/A pour location horaire',
      date: 'Date',
      time: 'Heure',
      search: 'RECHERCHER',
      searching: 'Recherche...',
    },
    testimonials: {
      title: 'Ce Que Disent Nos Clients',
      subtitle: 'Approuve par des milliers de voyageurs dans le monde',
      review1: 'Service parfait pour les transferts aeroport ! Le chauffeur m\'attendait avec une pancarte, tres professionnel.',
      review2: 'J\'utilise Zont pour tous mes voyages d\'affaires. Fiable, ponctuel, et les chauffeurs connaissent les meilleurs itineraires.',
      review3: 'Prix excellents et service de qualite. Je recommande vivement Zont !',
      name1: 'Marie Dubois',
      location1: 'Paris, France',
      name2: 'James Wilson',
      location2: 'Londres, UK',
      name3: 'Anna Petrosyan',
      location3: 'Erevan, Armenie',
    },
    cta: {
      title: 'Pret a Vivre un Transport Premium ?',
      subtitle: 'Rejoignez des milliers de clients satisfaits. Reservez votre premier trajet !',
      bookNow: 'RESERVER',
    },
    worldwide: {
      title: 'Votre Meilleure Option Mondiale',
      description: 'Avec un reseau mondial a la demande couvrant deja plus de',
      cities: '16 villes',
      description2: ', nous portons le transport a un nouveau niveau.',
    },
    footer: {
      description: 'Le moyen le plus intelligent de se deplacer en ville.',
      quickLinks: 'Liens Rapides',
      aboutUs: 'A Propos',
      terms: "Conditions d'Utilisation",
      privacy: 'Politique de Confidentialite',
      followUs: 'Suivez-Nous',
      copyright: '© 2025 Zont Technologies Inc. Tous droits reserves.',
    },
  },
  ru: {
    meta: {
      title: 'Zont - Премиум Транспорт и Трансфер из Аэропорта',
      description: 'Закажите профессиональных водителей и трансферы из аэропорта в более чем 16 городах мира. Отслеживание в реальном времени, прозрачные цены и поддержка 24/7.',
      keywords: 'трансфер из аэропорта, служба такси, частный водитель, заказ такси, транспортные услуги',
    },
    nav: {
      becomeDriver: 'Стать Водителем',
      becomeClient: 'Стать Клиентом',
      countries: 'Страны',
      help: 'Помощь',
      signin: 'Войти',
      signup: 'РЕГИСТРАЦИЯ',
      signout: 'Выйти',
      hello: 'Здравствуйте',
      myBookings: 'Мои бронирования',
      myAccount: 'Мой аккаунт',
    },
    hero: {
      title1: 'Нажмите Кнопку,',
      title2: 'Получите Поездку',
      subtitle: '- самый умный способ передвижения по городу.',
      getApp: 'Получите приложение для',
      iphone: 'iPhone',
      and: 'и',
      android: 'Android',
      downloadOn: 'Загрузить в',
      appStore: 'App Store',
      getItOn: 'ДОСТУПНО В',
      googlePlay: 'Google Play',
    },
    stats: {
      cities: 'Городов по Всему Миру',
      customers: 'Довольных Клиентов',
      drivers: 'Профессиональных Водителей',
      rating: 'Средний Рейтинг',
    },
    features: {
      title: 'Почему Выбирают Zont?',
      subtitle: 'Профессиональный транспортный сервис с лучшими ценами и высочайшими стандартами качества',
      confirmedBooking: 'Подтвержденное Бронирование',
      confirmedDesc: 'Мгновенное подтверждение и данные водителя за 3 часа до поездки',
      realTimeTracking: 'Отслеживание в Реальном Времени',
      realTimeDesc: 'Отслеживайте вашего водителя в реальном времени и точно знайте, когда он прибудет',
      professionalDrivers: 'Профессиональные Водители',
      professionalDesc: 'Все водители проверены, лицензированы и высоко оценены нашим сообществом',
      transparentPricing: 'Прозрачное Ценообразование',
      transparentDesc: 'Никаких скрытых платежей. Узнайте точную цену перед бронированием',
    },
    booking: {
      title: 'Забронируйте Трансфер из Аэропорта и Частного Водителя',
      description: 'Выбирайте из премиум седанов, роскошных автомобилей и бизнес-микроавтобусов по конкурентным ценам. Zont предоставляет профессиональные трансферы из аэропорта и услуги частного водителя по самым низким тарифам.',
      oneWay: 'В одну сторону',
      hourlyRental: 'Почасовая Аренда',
      pickup: 'Откуда',
      pickupPlaceholder: 'Откуда:',
      dropoff: 'Куда',
      dropoffPlaceholder: 'Куда:',
      hourlyNA: 'Н/Д для почасовой аренды',
      date: 'Дата',
      time: 'Время',
      search: 'ПОИСК',
      searching: 'Поиск...',
    },
    testimonials: {
      title: 'Отзывы Наших Клиентов',
      subtitle: 'Нам доверяют тысячи путешественников по всему миру',
      review1: 'Идеальный сервис для трансферов из аэропорта! Водитель ждал меня с табличкой, очень профессионально.',
      review2: 'Я использую Zont для всех своих деловых поездок. Надежно, вовремя, водители знают лучшие маршруты.',
      review3: 'Отличные цены и превосходный сервис. Я настоятельно рекомендую Zont!',
      name1: 'Мари Дюбуа',
      location1: 'Париж, Франция',
      name2: 'Джеймс Уилсон',
      location2: 'Лондон, UK',
      name3: 'Анна Петросян',
      location3: 'Ереван, Армения',
    },
    cta: {
      title: 'Готовы Испытать Премиум Транспорт?',
      subtitle: 'Присоединяйтесь к тысячам довольных клиентов. Забронируйте свою первую поездку!',
      bookNow: 'ЗАБРОНИРОВАТЬ',
    },
    worldwide: {
      title: 'Ваш Лучший Вариант по Всему Миру',
      description: 'С глобальной сетью по требованию, охватывающей уже более',
      cities: '16 городов',
      description2: ', мы выводим транспорт и мгновенный заказ на новый уровень.',
    },
    footer: {
      description: 'Самый умный способ передвижения по городу.',
      quickLinks: 'Быстрые Ссылки',
      aboutUs: 'О Нас',
      terms: 'Условия Использования',
      privacy: 'Политика Конфиденциальности',
      followUs: 'Следите за Нами',
      copyright: '© 2025 Zont Technologies Inc. Все права защищены.',
    },
  },
  hy: {
    meta: {
      title: 'Zont - Պրեմիում Տրանսպորտ և Օդանավակայանի Տրանսֆեր',
      description: 'Ամրագրեք պրոֆեսիոնալ վարորդներ և օդանավակայանի տրանսֆերներ 16 քաղաքներում: Իրական ժամանակի հետևելում, թաֆանցիկ գներ և 24/7 աջակցություն:',
      keywords: 'օդանավակայանի տրանսֆեր, մեքենայի ծառայություն, անձնական վարորդ, տաքսի ամրագրում',
    },
    nav: {
      becomeDriver: 'Դառնալ Վարորդ',
      becomeClient: 'Դառնալ Հաճախորդ',
      countries: 'Երկրներ',
      help: 'Օգնություն',
      signin: 'Մուտք',
      signup: 'ԳՌԱՆՑՎԵԼ',
      signout: 'Ելք',
      hello: 'Բարև',
      myBookings: 'Ամրագրումներ',
      myAccount: 'Իմ Հաշիվ',
    },
    hero: {
      title1: 'Սեղմեք Կոճակը,',
      title2: 'Ստացեք Ուղևորություն',
      subtitle: 'քաղաքում տեղաշարվելու ամենախելից միջոցն է:',
      getApp: 'Ներբեռնեք հավելվածը',
      iphone: 'iPhone',
      and: 'և',
      android: 'Android',
      downloadOn: 'Ներբեռնեք',
      appStore: 'App Store',
      getItOn: 'ՀԱՍԱՆԵԼԻ Է',
      googlePlay: 'Google Play',
    },
    stats: {
      cities: 'Քաղաքներ Աշխարհում',
      customers: 'Գոհ Հաճախորդներ',
      drivers: 'Պրոֆեսիոնալ Վարորդներ',
      rating: 'Միջին Վարկանիշ',
    },
    features: {
      title: 'Ինչու Ընտրել Zont-ը?',
      subtitle: 'Պրոֆեսիոնալ տրանսպորտային ծառայություն լավագույն գներով և բարձր որակի չափանիշներով',
      confirmedBooking: 'Հաստատված Ամրագրում',
      confirmedDesc: 'Ակնթարտ հաստատում և վարորդի տվյալներ վերցնելուց 3 ժամ առաջ',
      realTimeTracking: 'Իրական Ժամանակի Հետևելում',
      realTimeDesc: 'Հետևեք ձեր վարորդին իրական ժամանակում և իմացեք երբ նա կժամանի',
      professionalDrivers: 'Պրոֆեսիոնալ Վարորդներ',
      professionalDesc: 'Բոլոր վարորդները ստուգված են, լիցենզավորված և բարձր գնահատված',
      transparentPricing: 'Թաֆանցիկ Գնագոյացում',
      transparentDesc: 'Իմացեք ճիշտ գինը ամրագրելուց առաջ: Թաքնված վճարներ չկան',
    },
    booking: {
      title: 'Ամրագրեք Օդանավակայանի Տրանսֆեր և Անձնական Վարորդ',
      description: 'Ընտրեք պրեմիում սեդաններ, շքեղ մեքենաներ և բիզնես միկրոավտոբուսներ մրցունակ գներով:',
      oneWay: 'Միակողմանի',
      hourlyRental: 'Ժամային Վարձույթ',
      pickup: 'Վերցնելու վայր',
      pickupPlaceholder: 'Որտեղից:',
      dropoff: 'Իջնելու վայր',
      dropoffPlaceholder: 'Ուղղություն:',
      hourlyNA: 'Հ/Ա ժամային վարձույթի համար',
      date: 'Ամսաթիվ',
      time: 'Ժամ',
      search: 'ՈՌՈՆԵԼ',
      searching: 'Որոնում...',
    },
    testimonials: {
      title: 'Ինչ Ասում Են Մեր Հաճախորդները',
      subtitle: 'Վստահելի հազարավոր ճամորդողների կողմից',
      review1: 'Կատարյալ ծառայություն օդանավակայանի տրանսֆերի համար: Վարորդը սպասում էր ցուցանակով, շատ պրոֆեսիոնալ:',
      review2: 'Օգտագործում եմ Zont-ը բոլոր գործուղային ուղևորություններիս: Հուսալի, ժամանին:',
      review3: 'Հիանալի գներ և գերազանց ծառայություն: Խորհուրդ եմ տալիս Zont-ը!',
      name1: 'Marie Dubois',
      location1: 'Փարիզ, Ֆրանսիա',
      name2: 'James Wilson',
      location2: 'Լոնդոն, Մեծ Բրիտանիա',
      name3: 'Աննա Պետրոսյան',
      location3: 'Երևան, Հայաստան',
    },
    cta: {
      title: 'Պատրաստ՞ Եք Պրեմիում Տրանսպորտին:',
      subtitle: 'Միացեք հազարավոր գոհ հաճախորդներին: Ամրագրեք ձեր առաջին ուղևորությունը!',
      bookNow: 'ԱՄՌԱԳՌԵԼ',
    },
    worldwide: {
      title: 'Ձեր Լավագույն Համաշխարհային Ընտրությունը',
      description: 'Համաշխարհային ցանցով արդեն ընդգրկում է',
      cities: '16 քաղաքներ',
      description2: ', մենք տրանսպորտը տանում ենք նոր մակարդակ:',
    },
    footer: {
      description: 'Քաղաքում տեղաշարվելու ամենախելից միջոցը:',
      quickLinks: 'Արագ Հղումներ',
      aboutUs: 'Մեր Մասին',
      terms: 'Օգտագործման Պայմաններ',
      privacy: 'Գաղտնիության Քաղաքականություն',
      followUs: 'Հետևեք Մեզ',
      copyright: '© 2025 Zont Technologies Inc. Բոլոր իրավունքները պաշտպանված են:',
    },
  },
  es: {
    meta: {
      title: 'ZONT - Traslados privados en París con conductor',
      description: 'Reserva tu traslado privado en París con ZONT: aeropuerto CDG, Orly, Beauvais, Disneyland y hoteles. Precio fijo, conductor profesional y servicio 24/7.',
      keywords: 'traslado aeropuerto Paris, conductor privado Paris, taxi privado Paris, transfer Paris, traslado Disneyland Paris',
    },
    nav: {
      becomeDriver: 'Hazte conductor',
      becomeClient: 'Hazte cliente',
      countries: 'Paises',
      help: 'Ayuda',
      signin: 'Iniciar sesion',
      signup: 'REGISTRARSE',
      signout: 'Cerrar sesion',
      hello: 'Hola',
      myBookings: 'Mis reservas',
      myAccount: 'Mi cuenta',
    },
    hero: {
      title1: 'Pulsa un boton,',
      title2: 'reserva tu traslado',
      subtitle: 'es la forma mas inteligente de moverte por la ciudad.',
      getApp: 'Descarga la app para',
      iphone: 'iPhone',
      and: 'y',
      android: 'Android',
      downloadOn: 'Descarga en',
      appStore: 'App Store',
      getItOn: 'DESCARGAR EN',
      googlePlay: 'Google Play',
    },
    stats: {
      cities: 'Ciudades en el mundo',
      customers: 'Clientes satisfechos',
      drivers: 'Conductores profesionales',
      rating: 'Valoracion media',
    },
    features: {
      title: 'Por que elegir Zont?',
      subtitle: 'Servicio profesional de transporte con los mejores precios y la mas alta calidad',
      confirmedBooking: 'Reserva confirmada',
      confirmedDesc: 'Recibe confirmacion inmediata y los datos del conductor 3 horas antes de la recogida',
      realTimeTracking: 'Seguimiento en tiempo real',
      realTimeDesc: 'Sigue a tu conductor en tiempo real y conoce exactamente cuando llegara',
      professionalDrivers: 'Conductores profesionales',
      professionalDesc: 'Todos los conductores estan verificados, con licencia y muy bien valorados',
      transparentPricing: 'Precios transparentes',
      transparentDesc: 'Sin gastos ocultos. Conoce el precio exacto antes de reservar',
    },
    booking: {
      title: 'Reserva tu traslado al aeropuerto y servicio de conductor privado',
      description: 'Elige entre berlinas premium, vehiculos de lujo y minivans para grupos. Zont ofrece traslados privados al aeropuerto y servicio de conductor a precios competitivos en todo el mundo. Reserva tu taxi al aeropuerto, traslado urbano o alquiler con conductor por horas en cualquier ciudad. Sigue a tu conductor en tiempo real con garantia de calidad, seguridad y puntualidad.',
      oneWay: 'Solo ida',
      hourlyRental: 'Alquiler por horas',
      pickup: 'Recogida',
      pickupPlaceholder: 'Desde:',
      dropoff: 'Destino',
      dropoffPlaceholder: 'Hasta:',
      hourlyNA: 'No aplica para alquiler por horas',
      date: 'Fecha',
      datePlaceholder: 'dd/mm/aaaa',
      time: 'Hora',
      hours: 'Horas',
      adults: 'Adultos',
      kids: 'Ninos',
      kid: 'Nino',
      luggage: 'Maletas',
      bag: 'Maleta',
      bags: 'Maletas',
      searchVehicles: 'Buscar vehiculos',
      searching: 'Buscando...',
    },
    globalReach: {
      title: 'Alcance global',
      description: 'Nuestra red mundial cubre ya',
      cities: '16 ciudades',
      description2: ', y estamos llevando el transporte a un nuevo nivel.',
    },
    footer: {
      description: 'La forma mas inteligente de moverte por la ciudad.',
      quickLinks: 'Enlaces rapidos',
      aboutUs: 'Sobre nosotros',
      terms: 'Terminos de uso',
      privacy: 'Politica de privacidad',
      followUs: 'Siguenos',
      copyright: '\u00a9 2026 Zont Technologies Inc. Todos los derechos reservados.',
    },
  },
};
